module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"newpage":"新页面"},"en":{"newpage":"New Page"},"de":{"newpage":"Neue Seite"},"fr":{"newpage":"Nouvelle page"},"jp":{"newpage":"新しいページ"},"es":{"newpage":"Nueva pagina"},"it":{"newpage":"Nuova pagina"},"pt":{"newpage":"Nova página"},"tw":{"newpage":"新頁面"}}')
  delete Component.options._Ctor
}
